export const updateThemeSettings = () => ({
  type: 'UPDATE_THEME_SETTINGS'
})
